import { css } from "../../../../../styled-system/css";
import { token } from "../../../../../styled-system/tokens";

export const styles = {
  root: () =>
    css({
      position: "relative",
      gridArea: "image",
      display: "flex",
      flexDirection: "column",
      marginBottom: "baseUnit.mobile2",
    }),
  partnerLogo: () =>
    css({
      position: "absolute",
      zIndex: 1,
      transform: `translate(-${token("spacing.baseUnit.mobile2")}, ${token("spacing.baseUnit.mobile2")})`,
      mobile: {
        transform: `translate(${token("spacing.baseUnit.mobile2")}, ${token("spacing.baseUnit.mobile2")})`,
      },
    }),
  carImage: (isFallback: boolean) =>
    css({
      display: "flex",
      position: "relative",
      marginLeft: `calc(-${token("spacing.baseUnit.mobile4")})`,
      width: `calc(100% + 2 * ${token("spacing.baseUnit.mobile4")})`,
      aspectRatio: "464 / 348",
      marginTop: 0,
      mobile: {
        marginLeft: 0,
        width: "var(--width-for-desktop)",
        height: "var(--height-for-desktop)",
        aspectRatio: "auto",
      },
      ...(isFallback
        ? {
            backgroundColor: "disabledGrey",
          }
        : {
            "&::before": {
              content: '""',
              position: "absolute",
              inset: 0,
              background: "black",
              pointerEvents: "none",
            },
            "&::after": {
              content: '""',
              position: "absolute",
              inset: 0,
              background: "linear-gradient(180deg, rgba(0, 0, 0, 0.50) 11.72%, rgba(0, 0, 0, 0.00) 80%)",
              pointerEvents: "none",
            },
          }),
      "& img": {
        ...(isFallback
          ? undefined
          : {
              width: "100%",
              height: "100%",
              objectFit: "contain",
              position: "relative",
            }),
        margin: "auto",
      },
    }),
  imageDescription: () =>
    css({
      display: "flex",
      gap: `calc(${token("spacing.baseUnit.mobile1")} / 2)`,
    }),
  imageText: () =>
    css({
      fontSize: "body.butterfly",
      lineHeight: "body.butterfly",
      letterSpacing: "body.butterfly",
      marginBottom: 0,
    }),
};
